import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { NotificationIncidentAssignmentNotificationComponent } from '@lib/notification/feature-incident-assignment-notification';
import { IncidentReviewNotificationComponent } from '@lib/notification/feature-incident-review-notification';
import { SystemNotificationComponent } from '@lib/notification/feature-system-notification';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ReleaseNoteNotificationComponent } from '@lib/notification/release-note-notification';
import { IntegrationNotificationComponent } from '@lib/notification/integration-notification'

@Component({
  selector: 'lib-notification-feature-common-notification',
  standalone: true,
  imports: [
    ToastModule,
    NotificationIncidentAssignmentNotificationComponent,
    ReleaseNoteNotificationComponent,
    IncidentReviewNotificationComponent,
    SystemNotificationComponent,
    IntegrationNotificationComponent,
    RouterModule,
    AvatarModule
],
  templateUrl: './common-notification.component.html',
  styleUrl: './common-notification.component.scss',
})
export class CommonNotificationComponent {
  navigateToLink(link: string | undefined) {
    if(link){
        const baseUrl = window.location.origin;
        window.open(`${baseUrl}/${link}`, '_blank');
    }
  }
}

